import React, { useContext, useEffect } from 'react';
import { buildInteractiveResult } from '@coveo/headless';
import SearchContext from '../../state/context';
import { filterProtocol, setCurrentCommunityCookie } from '../../helpers';

const ResultLink = props => {
  const { engine } = useContext(SearchContext);
  const { result = {}, className = '' } = props;

  const interactiveResult = buildInteractiveResult(engine, {
    options: { result: result }
  });

  useEffect(() => () => interactiveResult.cancelPendingSelect(), []);

  const ctaClick = (e) => {
    e.preventDefault();

    if (result.ssl_communityid) {
      setCurrentCommunityCookie(result);
    }

    interactiveResult.select();

    const { Boxever, _boxever_settings } = window;

    const eventToSend = {
      channel: 'WEB',
      type: 'Community_Carousel_Click',
      pos: window._boxever_settings.pointOfSale,
      browser_id: Boxever.getID()
    };

    Boxever.eventCreate(
      eventToSend,
      data => {
        window.location = result.clickUri;
      },
      'json'
    );
  }

  return (
    <a
      className={className}
      href={result.clickUri ? filterProtocol(result.clickUri) : '#'}
      onClick={ctaClick}
      onContextMenu={() => interactiveResult.select()}
      onMouseDown={() => interactiveResult.select()}
      onMouseUp={() => interactiveResult.select()}
      onTouchStart={() => interactiveResult.beginDelayedSelect()}
      onTouchEnd={() => interactiveResult.cancelPendingSelect()}
    >
      {props.children}
    </a>
  );
};

export default ResultLink;
